import { memo } from 'react';
import { Text, Flex } from '@chakra-ui/react';
import { ThemedFlex } from '../../theme/ThemedFlex';
import { useThemedStyles } from '../../hooks/useThemedStyles';

export const FearGreedIndexTile = memo(({ data, animate }) => {
  const { colors } = useThemedStyles();
  const fearGreedData = data?.s16?.fear_greed?.data;
  const current = fearGreedData?.[0];
  const classification = current?.value_classification || 'Loading...';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <Flex direction="column" gap="6px" textAlign="center">
        <Text
          fontSize={{ base: "12px", sm: "11px", '2xl': "12px" }}
          color={colors.text.label}
          fontWeight="700"
          lineHeight="1"
          textTransform="uppercase"
        >
          Sentiment
        </Text>
        <Text
          fontSize={{ base: "18px", sm: "20px", md: "24px", '2xl': "26px" }}
          fontWeight="700"
          lineHeight="1"
          color={colors.text.primary}
        >
          {classification}
        </Text>
      </Flex>
    </ThemedFlex>
  );
});
